import useCampaignBaseInfoCache from 'components/business/hooks/useCampaignBaseInfoCache'
import { message, openAlertModal } from 'components/ui'
import useTranslation from 'next-translate/useTranslation'
import { Campaign, useUpdateCampaignMutation } from 'types/domain'

const useCampaignFormStatusSwitch = (id: string) => {
  const { t } = useTranslation('common')
  const { campaign } = useCampaignBaseInfoCache(id)
  const [updateMutation] = useUpdateCampaignMutation()

  const urlEnabled = campaign?.urlEnabled

  const sendRequest = async (callback?: (campaign: Campaign) => void) => {
    const input = {
      id,
      urlEnabled: !urlEnabled,
    }
    updateMutation({ variables: { input } }).then(() => {
      message.successMsg(t('message.updateSuccess'))
      callback?.({ ...(campaign as Campaign), urlEnabled: !urlEnabled })
    })
  }
  const toggle = async (callback?: (campaign: Campaign) => void) => {
    if (urlEnabled) {
      openAlertModal({
        title: t('common:tip.title'),
        content: t('componentCampaignList:statusSwitcher.confirmContent.link'),
        onConfirm: () => sendRequest(callback),
      })
    } else {
      await sendRequest(callback)
    }
  }
  return {
    toggle,
  }
}

export default useCampaignFormStatusSwitch
